/*
 * Public API Surface of ngrx-devtools-nativescript
 */

export * from './lib/ngrx-devtools-nativescript.module';
